import React, { useEffect } from 'react'
import ReactModal from 'react-modal'

import * as Styled from './Modal.styles'

const Modal = ({
  children = null,
  closeTimeoutMS = 300,
  hasMegaForm = false,
  isShowing = false,
  onClose = null,
  size = 'lg',
  noExit = false,
  ...props
}) => {
  // Setting the app element is required for accessibility reasons
  // http://reactcommunity.org/react-modal/accessibility/
  useEffect(() => {
    ReactModal.setAppElement('body')
  }, [])

  return (
    <ReactModal
      closeTimeoutMS={closeTimeoutMS}
      isOpen={isShowing}
      o
      onRequestClose={!noExit && onClose}
      className={`ReactModal__CustomOverlay leshen-modal leshen-modal-${size} ${
        hasMegaForm ? 'contains-mega-form' : ''
      }`}
      overlayClassName="ReactModal__CustomContent"
      {...props}
    >
      {!noExit && (
        <Styled.CloseButton
          aria-label="Close"
          tabIndex="0"
          data-testid="modal-close"
          onClick={onClose}
          className="close"
          hasMegaForm={hasMegaForm}
        >
          <Styled.CloseIcon className="button" height={20} width={20} />
        </Styled.CloseButton>
      )}
      {children}
    </ReactModal>
  )
}

export default Modal
